import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import type { MaintenanceRouteFactory } from "./maintenanceRouteContext";

const ScheduleMaintenanceListScreen = lazyRouteComponent(
  () => import("../ScheduleMaintenanceListScreen"),
  "ScheduleMaintenanceListScreen",
);

export const createScheduleMaintenanceRoutes: MaintenanceRouteFactory = ({
  context,
}) => [
  createRoute({
    getParentRoute: context.getParentRoute,
    path: `${context.basePath}/schedules`,
    component: ScheduleMaintenanceListScreen,
  }),
];
